import { api } from './api';


export const tagsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTags: build.query({
      query: () => ({
        url: "tags",
      }),

      transformResponse: (response) => response.data,
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ details }) => ({ type: 'Tags', id: details?.ID })),
            { type: 'Tags', id: 'LIST' },
          ]
          : [{ type: 'Tags', id: 'LIST' }],
    }),
    getTagsWithFilter: build.query({
      query: (filter) => ({
        url: "tags",
        method: "POST",
        body: JSON.stringify(filter)
      }),
      transformResponse: (response) => response.data,
    }),
    getCounts: build.query({
      query: () => ({
        url: "counts",
      }),
      transformResponse: (response) => response.data,
    }),
    renameTag: build.mutation({
      query: ({ id, label, force = false }) => ({
        url: `tag/${id}`,
        method: 'PUT',
        body: JSON.stringify({ label, force }),
      }),
      // Renaming may fold one tag into another, which changes the tag list
      // and may also rewrite element-tag joins. Invalidate both so the
      // gallery and any open element form pick up the new labels.
      invalidatesTags: (_result, error) =>
        error ? [] : [{ type: 'Tags', id: 'LIST' }, { type: 'Elements', id: 'LIST' }],
    }),
    deleteTag: build.mutation({
      query: (id) => ({
        url: `tag/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, error) =>
        error ? [] : [{ type: 'Tags', id: 'LIST' }, { type: 'Elements', id: 'LIST' }],
    }),
    mergeTags: build.mutation({
      query: ({ sourceId, targetId }) => ({
        url: 'tags/merge',
        method: 'POST',
        body: JSON.stringify({ source_id: sourceId, target_id: targetId }),
      }),
      invalidatesTags: (_result, error) =>
        error ? [] : [{ type: 'Tags', id: 'LIST' }, { type: 'Elements', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetTagsQuery,
  useLazyGetTagsWithFilterQuery,
  useGetCountsQuery,
  useRenameTagMutation,
  useDeleteTagMutation,
  useMergeTagsMutation,
} = tagsApi;
